module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Crickonnect","short_name":"Crickonnect","start_url":"/","background_color":"#ffffff","theme_color":"#d32f2f","display":"standalone","icon":"src/images/fvicon.png","icon_options":{"purpose":"any maskable"},"description":"Cricket tools, trivia, and stories for grassroots cricket fans","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8b310c399bfcb751c23d94bb2dd76614"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
